import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { flattenize } from "./flattenize.operator";

	/**
     * @description
     *  Permite serializar la emisión de observables al igual que el operador
	 *	'flattenize', pero aplicando una transformación adicional sobre el
	 *	valor emitido. Esto permite concatenar múltiples operaciones
	 *	asincrónicas, donde es requerido garantizar la serialización de las
	 *	mismas.
     *
	 * @param mapper
	 *	La función de transformación del valor en el observable anidado.
	 *
     * @returns
     *  Un observable con un nivel inferior de anidamiento, y cuyo valor fue
	 *	mapeado a otro tipo.
     */

export function flatMap<T, U>(mapper: (value: T) => Observable<U>): (source: Observable<T>) => Observable<U> {
    return function (source: Observable<T>): Observable<U> {
        return source.pipe(
			map(value => mapper(value)),
            flattenize()
        );
    };
}
